<div class="w-full flex flex-row justify-center items-center px-10 bg-white border border-zen-paleWhite sticky bot h-fit min-h-20">
  <div class="flex flex-row items-center h-fit w-full-75 justify-between xl:max-w-4.5xl px-10 xl:px-0 ">
    <ng-content select="[left]"></ng-content>
    <div class="flex flex-row items-center justify-end">
      <ng-content select="[right]"></ng-content>
    </div>
  </div>
</div>
